import classNames from 'classnames';

import {
  OUTLINE_TAG_SIZE_S,
  OUTLINE_TAG_SIZE_XS,
  OUTLINE_TAG_VARIANT_PRIMARY,
  OUTLINE_TAG_VARIANT_WARNING,
  OutlineTagProps,
} from './outline-tag.type';

export const OUTLINE_TAG_TEST_ID = 'outline-tag';

export const OutlineTag = ({
  children,
  size = OUTLINE_TAG_SIZE_S,
  variant = OUTLINE_TAG_VARIANT_PRIMARY,
  className,
  dataTestId = OUTLINE_TAG_TEST_ID,
}: OutlineTagProps) => (
  <span
    data-testid={dataTestId}
    className={classNames(
      'inline-flex items-center border uppercase',
      {
        'px-2 py-1.5 text-actions-s': size === OUTLINE_TAG_SIZE_S,
        'px-1.5 py-1 text-body-xs font-medium': size === OUTLINE_TAG_SIZE_XS,
        'border-primary text-primary': variant === OUTLINE_TAG_VARIANT_PRIMARY,
        'border-warning-no-bg text-warning': variant === OUTLINE_TAG_VARIANT_WARNING,
      },
      className
    )}>
    {children}
  </span>
);
